import { render } from "./ProjectFormModal.vue?vue&type=template&id=c5070c2c"
import script from "./ProjectFormModal.vue?vue&type=script&lang=js"
export * from "./ProjectFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__